export const libraryQueryKeys = {
	myCard: {
		all: ["myCard"] as const,
		byId: (cardId: string) => [...libraryQueryKeys.myCard.all, cardId] as const,
		ofId: (cardId: string, shareKey?: string | null) =>
			[...libraryQueryKeys.myCard.byId(cardId), shareKey ?? null] as const,
	},
	entities: {
		all: ["libraryEntities"] as const,
		list: (params: {
			scope?: string | null;
			type?: string | null;
			search?: string | null;
			limit?: number;
		}) => [...libraryQueryKeys.entities.all, params] as const,
	},
	entityTypeCounts: {
		all: ["libraryEntityTypeCounts"] as const,
		list: (params: {
			scope?: string | null;
			search?: string | null;
		}) => [...libraryQueryKeys.entityTypeCounts.all, params] as const,
	},
};
